import script from "./ViewAllLibraryTalks.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllLibraryTalks.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllLibraryTalks.vue?vue&type=style&index=0&id=d501900e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d501900e"]])

export default __exports__